const INITIAL_STATE = {
  data: {},
  errors: {},
        
}
const resendInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'RESEND_INVOICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'RESEND_INVOICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default resendInvoice;